const {Component} = require("react");
const {observer} = require("mobx-react");
const store = require("stores/UserStore");

@observer
class NameTag extends Component {

	get text() {
		let name = store.get("nickname");
		let age = store.get("age");
		let parts = [name];

		if (age) {
			parts.push(age);
		}

		return parts.join(", ");
	}

	render() {
		return (<h2>{this.text}</h2>)
	}

}

module.exports = NameTag;


// WEBPACK FOOTER //
// ./resources/js/components/backend/NameTag.js